// import React from "react";
import "./Css/ExamView.css";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import React, { useState, useEffect } from "react";
import API_BASE from "../config/api";

const students = [
  {
    id: 1,
    studentId: "STD123456",
    name: "आर्य पाटील",
    roll: "१५",
    email: "aryan.patil@gmail.com",
    teacher: "सौ. प्रिया देशमुख",
    status: "सक्रिय",
  },
  {
    id: 2,
    studentId: "STD123456",
    name: "संकेत जाधव",
    roll: "१२",
    email: "sanket.j@gmail.com",
    teacher: "श्री. अमित जाधव",
    status: "निष्क्रिय",
  },
  {
    id: 3,
    studentId: "STD123456",
    name: "अमेय शिंदे",
    roll: "२२",
    email: "amey.shende@gmail.com",
    teacher: "सौ. नेहा पाटील",
    status: "निष्क्रिय",
  },
];

const ExamDetails = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [paper, setPaper] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadPaper = async () => {
    try {
      const res = await axios.get(
        `${API_BASE}/api/Papers/${id}`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`
          }
        }
      );

      setPaper(res.data);
    }
    catch (err) {
      console.error(err);
      alert("Failed to load paper");
    }
    finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadPaper();
  }, [id]);


  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const d = new Date(dateString);
    return d.toLocaleDateString("en-GB"); // DD/MM/YYYY
  };

  const getDurationMinutes = (start, end) => {
    if (!start || !end) return "-";

    const s = new Date(`1970-01-01T${start}`);
    const e = new Date(`1970-01-01T${end}`);

    return Math.round((e - s) / 60000) + " मिनिटे";
  };

  const handleEditClick = (id) => {
    navigate(`/dashboard/examedit/${id}`);
  };

  if (loading) return <p>Loading paper...</p>;
  if (!paper) return <p>Paper not found</p>;
  return (
    <div className="exam-container">
      <div className="page-header">
        <h3 style={{ cursor: "pointer" }}
          onClick={() => navigate(-1)}>
          परीक्षा व्यवस्थापन  &gt;&gt; <span>परीक्षा तपशील</span>
        </h3>
        <button className="edit-btn" onClick={() => handleEditClick(id)} >एडिट करा</button>
      </div>
      <h2>परीक्षा तपशील</h2>
      {/* Form Section */}
      <div className="exam-form">
        <div className="form-group">
          <label>परीक्षेचे नाव</label>
          <input value={paper.softwareName} readOnly />
        </div>

        <div className="form-group">
          <label>परीक्षा प्रकार</label>
          <input value={paper.paperType} readOnly />
        </div>

        <div className="form-group">
          <label>इयत्ता</label>
          <input value={paper.standardName} readOnly />
        </div>

        <div className="form-group">
          <label>विषय</label>
          <input value={paper.subjectName} readOnly />
        </div>

        <div className="form-group">
          <label>परीक्षेची तारीख</label>
          <input value={formatDate(paper.paperDate)} readOnly />
        </div>

        <div className="form-group">
          <label>कालावधी</label>
          <input value={getDurationMinutes(paper.paperStartTime, paper.paperEndTime)} readOnly />
        </div>

        <div className="form-group">
          <label>एकूण गुण</label>
          <input value={paper.marks} readOnly />
        </div>

        <div className="form-group">
          <label>परीक्षा स्थिती</label>
          <input value={paper.paperStatus} className="status-active" readOnly />
        </div>
      </div>

      {/* Table */}
      {/* <div className="table-wrapper">
        <table>
          <thead>
            <tr>
              <th>क्र.</th>
              <th>विद्यार्थी ID</th>
              <th>विद्यार्थी नाव</th>
              <th>रोल नं</th>
              <th>ईमेल</th>
              <th>नियुक्त शिक्षक</th>
              <th>स्थिती</th>
            </tr>
          </thead>
          <tbody>
            {students.map((s, index) => (
              <tr key={s.id}>
                <td>{index + 1}</td>
                <td>{s.studentId}</td>
                <td>{s.name}</td>
                <td>{s.roll}</td>
                <td>{s.email}</td>
                <td>{s.teacher}</td>
                <td
                  className={
                    s.status === "सक्रिय"
                      ? "status-green"
                      : "status-gray"
                  }
                >
                  {s.status}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div> */}
    </div>
  );
};

export default ExamDetails;
